var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 9.99997,
    width: 6.7294,
    height: 6.7294,
    rx: 2.52353,
    fill: "#D7D9E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0938,
    y: 6.63527,
    width: 6.7294,
    height: 10.0941,
    rx: 2.52353,
    fill: "#9698A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrend);
export default __webpack_public_path__ + "static/media/trend.50acbdb819af67a831ee801d7a9c0349.svg";
export { ForwardRef as ReactComponent };